
import { supabase } from '@/integrations/supabase/client';

/**
 * Универсальная функция для обновления любого поля курьера
 * @param courierId - ID курьера
 * @param field - Имя поля для обновления
 * @param value - Новое значение
 * @returns Результат операции
 */
export const updateCourierField = async (courierId: string, field: string, value: any) => {
  try {
    const updateData = {
      [field]: value,
      updated_at: new Date().toISOString()
    };

    const { data, error } = await supabase
      .from('couriers')
      .update(updateData)
      .eq('id', courierId)
      .select();
    
    return { ok: !error, data, error };
  } catch (error) {
    console.error(`Ошибка при обновлении поля ${field} курьера:`, error);
    return { ok: false, data: null, error };
  }
};

/**
 * Обновление паспортных данных курьера
 * @param courierId - ID курьера
 * @param passportData - Паспортные данные
 * @returns Результат операции
 */
export const updateCourierPassportData = async (
  courierId: string,
  passportData: {
    passport_number?: string;
    registration_address?: string;
  }
) => {
  try {
    const { data, error } = await supabase
      .from('couriers')
      .update({
        ...passportData,
        updated_at: new Date().toISOString()
      })
      .eq('id', courierId)
      .select();
    
    return { ok: !error, data, error };
  } catch (error) {
    console.error('Ошибка при обновлении паспортных данных курьера:', error);
    return { ok: false, data: null, error };
  }
};

/**
 * Обновление информации об аренде курьера
 * @param courierId - ID курьера
 * @param rentalData - Данные об аренде
 * @returns Результат операции
 */
export const updateCourierRentalInfo = async (
  courierId: string,
  rentalData: {
    deal_number?: string;
    tariff?: string;
    tariff_price?: number;
    rental_start_ts?: number;
    rental_end_ts?: number;
    last_payment_date?: string;
  }
) => {
  try {
    const { data, error } = await supabase
      .from('couriers')
      .update({
        ...rentalData,
        updated_at: new Date().toISOString()
      })
      .eq('id', courierId)
      .select();
    
    return { ok: !error, data, error };
  } catch (error) {
    console.error('Ошибка при обновлении информации об аренде курьера:', error);
    return { ok: false, data: null, error };
  }
};
